module.exports = __webpack_public_path__ + "static/media/service1.56af3126.png";